import React from 'react';
import { Col, Form } from 'antd';

import { useApplicationContext } from '@/context/v1/Application/context';
import { CycleSelect } from '@/components/ui/Inputs/CycleSelect';
import { useCycles } from '@/hooks/v1';
import FormItem from '@/components/ui/FormItem';

const { useFormInstance, useWatch } = Form;

interface CyclesProps {
	disabled?: boolean;
	onValueChange: (changed: boolean) => void;
}

export function Cycles({ disabled = false, onValueChange }: Readonly<CyclesProps>): JSX.Element {
	const form = useFormInstance();
	const { setFieldValue } = useFormInstance();
	const { organization } = useApplicationContext();

	const companyId = useWatch('company_id', form);
	const cycleId = useWatch('cycle_id', form);

	const {
		data: cycles,
		isLoading,
		isFetching,
		isError
	} = useCycles({
		organization_id: organization?.id,
		company_id: companyId
	});

	function handleCycleSelect(id: string) {
		onValueChange(true);
		setFieldValue(['cycle_id'], id);
	}

	function handleClearCycles() {
		setFieldValue(['cycle_id'], undefined);
	}

	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['cycle_id']}
				label="Cycle"
				labelCol={{ span: 24 }}
				requiredMessage="Select the cycle"
				required
			>
				<CycleSelect
					size="large"
					cycles={cycles}
					cycleId={cycleId}
					loading={isFetching}
					companyId={companyId}
					fieldName="cycle_id"
					handleSelectCycle={handleCycleSelect}
					handleClearCycles={handleClearCycles}
					disabled={disabled || isLoading || isFetching || isError || !companyId}
				/>
			</FormItem>
		</Col>
	);
}
